import { createContext, useContext } from "react";
import {
  IWebsiteBuilderToolbarState,
  THandleSetToolbarMenuType,
} from "../hooks/toolbarState/useWebsiteBuilderToolbarState";

interface IWebsiteBuilderToolbarContext {
  toolbarState: IWebsiteBuilderToolbarState;
  handleSetToolbarMenuType: THandleSetToolbarMenuType;
}

const defaultContext: IWebsiteBuilderToolbarContext = {
  toolbarState: null,
  handleSetToolbarMenuType: null,
};

export const WebsiteBuilderToolbarContext = createContext<IWebsiteBuilderToolbarContext>(defaultContext);
export const useWebsiteBuilderToolbarContext = () => useContext(WebsiteBuilderToolbarContext);
